import { Portal } from '@aviv-estimation-funnel/estimation-data-models/enums';
import { useTranslation } from '@aviv-unified-frontend/runtime/i18n';
import { NAME_SPACE } from '@mfe-presentation/hooks/useLoadTranslations';
import { useEffect } from 'react';

export const useBrowserTitle = (portal: Portal) => {
    const { t } = useTranslation(NAME_SPACE);
    const prefix =
        process.env.NX_TASK_TARGET_CONFIGURATION === 'production'
            ? ''
            : `[${process.env.NX_TASK_TARGET_CONFIGURATION?.toUpperCase()}] `;

    const titleKey = `common.browser.title.${portal.toLowerCase()}`;

    useEffect(() => {
        document.title = `${prefix}${t(titleKey)}`;
    }, []);
};
